import * as Scrivito from "scrivito";
import RecentProjectsLinkWidget from "widgets/RecentProjectsLinkWidget/RecentProjectsLinkWidgetClass";

Scrivito.provideEditingConfig("RecentProjectsWidget", {
  title: "Recent Projects",
  attributes: {
    redirectToProjectCreate: {
      title: "Redirection target after project creation",
      description:
        "Reference where user should be redirected after Project creation",
    },
    redirectToProjectItem: {
      title: "Redirection target after click on Project item",
      description:
        "Reference where user should be redirected after click on the Project item",
    },
  },
  properties: [
    "leftLinks",
    "rightLinks",
    "btnText",
    "sideToShow",
    "listTitle",
    "projectCountSingle",
    "projectCountPlural",
    "redirectToProjectCreate",
    "redirectToProjectItem",
  ],
  initialContent: {
    leftLinks: [
      new RecentProjectsLinkWidget({
        title: "My Projects",
        withProjectCountDescription: true,
        withIcon: false,
      }),
    ],
    rightLinks: [
      new RecentProjectsLinkWidget({
        title: "products",
        withIcon: true,
        withProjectCountDescription: false,
        iconName: "cube-regular",
        description: ["Product Finder", "Configuration", "Technical Design"],
      }),
      new RecentProjectsLinkWidget({
        title: "wizards",
        withIcon: true,
        withProjectCountDescription: false,
        iconName: "magic-wand-regular",
        description: ["Guided Product Selection", "Configuration"],
      }),
      new RecentProjectsLinkWidget({
        title: "library",
        withIcon: true,
        withProjectCountDescription: false,
        description: ["TROX Templates", "Custom Library", "Create new project"],
      }),
    ],
    btnText: "Create New Project",
    sideToShow: "both",
    listTitle: "Latest files",
    projectCountSingle: "saved Project",
    projectCountPlural: "saved Projects",
  },
  validations: [
    [
      "redirectToProjectCreate",
      (attr) => {
        if (!attr) {
          return {
            message: "RedirectToProjectCreate attribute should be set.",
            severity: "warning",
          };
        }
      },
    ],
    [
      "redirectToProjectItem",
      (attr) => {
        if (!attr) {
          return {
            message: "RedirectToProjectItem attribute should be set.",
            severity: "warning",
          };
        }
      },
    ],
  ],
});
